export default "__VITE_ASSET__DF3u5CER__"